import { css } from '@emotion/css';

const externalRangeSelectionSelector =
  'affine-table[data-external-range-selection]';
const hiddenSelectionBackground = '#fff';

export const tableContainer = css({
  display: 'block',
  padding: '10px 0 18px 10px',
  overflowX: 'auto',
  overflowY: 'visible',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  '& *': {
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  [`${externalRangeSelectionSelector} &::selection`]: {
    backgroundColor: hiddenSelectionBackground,
  },
  [`${externalRangeSelectionSelector} & *::selection`]: {
    backgroundColor: hiddenSelectionBackground,
  },
  [`${externalRangeSelectionSelector} & rich-text::selection`]: {
    backgroundColor: hiddenSelectionBackground,
  },
  [`${externalRangeSelectionSelector} & rich-text *::selection`]: {
    backgroundColor: hiddenSelectionBackground,
  },
  '::-webkit-scrollbar': {
    height: '8px',
  },
  '::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'transparent',
  },
  '::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'transparent',
    height: '8px',
  },
  '&:hover::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '&:hover::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
  // tuninho: em aparelho de TOQUE não existe hover — a barra de rolagem horizontal fica
  // visível sempre, senão a tabela mais larga que a tela parece cortada (card
  // 1878477726868833575, medido no iPhone: 3ª coluna fora da tela, sem sinal de que rola).
  '@media (pointer: coarse)': {
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar-thumb:horizontal': {
      borderRadius: '4px',
      backgroundColor: 'var(--affine-black-30)',
    },
    '&::-webkit-scrollbar-track:horizontal': {
      backgroundColor: 'var(--affine-hover-color)',
      height: '8px',
    },
  },
  // tuninho: em tela estreita a coluna não passa de um terço da largura útil, para que uma
  // tabela de até três colunas CAIBA sem rolar e as mais largas rolem com colunas legíveis.
  // Os 80px descontam o recuo da página, o padding deste contêiner e as bordas das células —
  // medido a 390px: com 56px sobravam 11px de rolagem (363 de conteúdo em 352 de área).
  // As larguras do modelo (`min-width`/`max-width` inline em `tdStyle`) valem a partir do
  // tablet; aqui a tela manda. `!important` porque o inline ganharia de qualquer seletor.
  '@media (max-width: 640px)': {
    '& td': {
      minWidth: '72px !important',
      maxWidth: 'calc((100vw - 80px) / 3) !important',
    },
  },
});

export const tableWrapper = css({
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  position: 'relative',
  width: 'max-content',
});

export const table = css({});

export const rowStyle = css({});
